import React, { useState, useEffect, Fragment, Children } from 'react'
import { Form } from 'react-bootstrap'
import MyCard from './MyCard'

function MyFormWrapper(props) {
    // console.log('props:',props)
    // console.log('children:',props.children)
    useEffect(() => {
        
    }, [props])
    
    return (
        <>
        {
            props?.type === 'show-details'
            ?
                <div className="row g-3">    
                {
                    props?.fields?.length > 0 &&
                    props?.fields?.map((f,f_index) => {
                        return (
                            <MyCard 
                                type={props?.type}
                                key={f_index} 
                                fields_dic_prefix={props?.fields_dic_prefix[f_index]}
                                fields={f}
                                title={props?.title[f_index]}
                                showErrors={(f_index === props?.showErrorsIndex || (props?.showErrorsIndex === undefined && f_index === 0 )) && 1}
                                showButtons={(f_index === props?.showButtonsIndex || (props?.showButtonsIndex === undefined && f_index === 0 )) && 1}
                                bs_grid={(props?.bs_grid !== undefined && props?.bs_grid[f_index] !== undefined) ? props?.bs_grid[f_index] : [12]}

                                control={props?.control} 
                                getValues={props?.getValues} 
                                reset={props?.reset}
                                errors={props?.errors}

                                extraFunctions={props?.extraFunctions}
                                extraComponents={props?.extraComponents !== undefined && props?.extraComponents[f_index]}
                            />
                        )
                    })
                }
                </div>
            :
                <Form onSubmit={props?.handleSubmit(props?.onSubmit)} className="row g-3">
                    {
                        props?.fields?.length > 0 &&
                        props?.fields?.map((f,f_index) => {
                            return (
                                <MyCard 
                                    key={f_index} 
                                    fields_dic_prefix={props?.fields_dic_prefix[f_index]}
                                    fields={f}
                                    title={props?.title[f_index]}
                                    serverErrors={props?.serverErrors}
                                    // serverErrors={(f_index === props?.showErrorsIndex || (props?.showErrorsIndex === undefined && f_index === 0 )) && 1}
                                    showErrors={(f_index === props?.showErrorsIndex || (props?.showErrorsIndex === undefined && f_index === 0 )) && 1}
                                    showButtons={(f_index === props?.showButtonsIndex || (props?.showButtonsIndex === undefined && f_index === 0 )) && 1}
                                    bs_grid={(props?.bs_grid !== undefined && props?.bs_grid[f_index] !== undefined) ? props?.bs_grid[f_index] : [12]}

                                    control={props?.control} 
                                    getValues={props?.getValues} 
                                    reset={props?.reset}
                                    errors={props?.errors}

                                    buttonTitle={props?.buttonTitle}

                                    extraFunctions={props?.extraFunctions}
                                >
                                    {props?.children}
                                </MyCard>
                            )
                        })
                    }
                </Form>
        }
            
        </>
    )
}


export default MyFormWrapper;